// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FILTER_MODAL_CLOSE = "Zavrie\u0165";
export const BZ2_FILTER_PRICE_MAX = "Cena do";
export const BZ2_FILTER_PRICE_MIN = "Cena od";
